/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */
export default angular.module('tektelic.components.frequencyConverter', [])
    .directive('tkFrequencyConverter', FrequencyConverter)
    .name;

/*@ngInject*/
function FrequencyConverter() {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function (scope, elem, attrs, ngModel) {
            ngModel.$parsers.push(function (frequencyMHz) {
                let frequencyHz = frequencyMHz * 1000000;
                return frequencyHz;
            });
            ngModel.$formatters.push(function (frequencyHz) {
                let frequencyMHz = frequencyHz / 1000000;
                return frequencyMHz;
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/frequency-converter.directive.js